/** Base pathname for LinkedIn profile APIs. */
export const PROFILE_BASE_PATH = '/rec/profile';

export const PROFILE_ENDPOINTS = {
  search: `${PROFILE_BASE_PATH}/search`,
  byId: (profileId: string | number) => `${PROFILE_BASE_PATH}/search/${profileId}`,
} as const;
